<template>
  <div class="gray-background">
    <div class="d-flex align-items-center gap-20 container mb-5">
      <div class="">
        <iframe
          width="424"
          height="238"
          :src="data.about_us_link"
          title="The Vision of Banknote World"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <div class="d-flex flex-column justify-content-center w-100">
        <p class="paragraph" v-html="data.about_text_area" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoSection",
  props: ["data"]
}
</script>

<style scoped>
.gray-background {
  background-color: #e9f2f9;
  margin: 10rem 0;
}

.container {
  max-width: 1440px;
}

iframe {
  width: 500px;
  height: 450px;
  margin: -3rem 0;
  border-radius: 12px;
}

h3 {
  font-size: 38px;
  color: #DEAA5E;
  text-transform: uppercase;
}

.paragraph {
  line-height: 40px;
  text-transform: uppercase;
  font-size: 18px;
  padding: 1rem 0;
}

.gap-20 {
  gap: 20px;
}

@media screen and (max-width: 1024px) {
  h4 {
    margin-top: 2rem;
  }
}

@media screen and (max-width: 768px) {
  .gray-background {
    margin: 3rem 0;
  }

  .gray-background .container {
    flex-direction: column;
  }

  iframe {
    width: 100%;
    height: 200px;
    margin: 1rem 0;
  }

  h3 {
    margin-top: 0;
  }

  .paragraph {
    padding-bottom: 1rem;
  }
}
</style>
